module.exports = __webpack_public_path__ + "static/media/scroll-old.7ca40d85.svg";